import { FormEvent, useState } from 'react';
import { Dialog } from '@/components/ui/Dialog';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { api } from '@/lib/api';
import { useToast } from '@/components/ui/Toast';

export function AddCategoryDialog({
  open,
  onOpenChange,
  siteId,
  onCreated,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  siteId: number;
  onCreated: () => void;
}) {
  const [slug, setSlug] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const { push } = useToast();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.createCategory(siteId, slug.trim(), name.trim());
      push(`카테고리 "${name}" 생성됨`, 'success');
      setSlug('');
      setName('');
      onOpenChange(false);
      onCreated();
    } catch (err) {
      push(err instanceof Error ? err.message : '생성 실패', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange} title="새 카테고리 추가">
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="mb-1 block text-xs font-medium">slug</label>
          <Input
            required
            autoFocus
            pattern="[a-z0-9-]{1,40}"
            placeholder="예: services, partners, banners"
            value={slug}
            onChange={(e) => setSlug(e.target.value.toLowerCase())}
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium">표시 이름</label>
          <Input required placeholder="예: Service / Partners" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            취소
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? '생성 중…' : '생성'}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
